module.exports = __webpack_public_path__ + "img/scroll-indicator-light.bd01625.svg";